export default function Loader() {
    return (
        <div className="text-center mt-32">
            <div
                className="w-16 h-16 border-4 border-dashed rounded-full animate-spin border-primary800 mx-auto"
            ></div>
            <h2 className="text-primary800 dark:text-white mt-4">Loading...</h2>
        </div>

    )
}